import ResultGrid from './ResultGrid';

export default ResultGrid;
